<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title1">
      {{title}}
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
  </div>

  <div class="modal-body">
    <p><strong>{{accountCode}}:</strong> {{description}}</p>

    <div class="mb-3 row">
      <label class="col-md-4 col-form-label">Refund Amount(RM)</label>
      <div class="col-md-8">
        <input type="number" formControlName="amount" class="form-control" min="0.01" [max]="maxRefundable" step="0.01"
          [ngClass]="{'is-invalid': submitted && f.amount.errors}" />
        @if (submitted && f.amount.errors) {
          <div class="invalid-feedback">
            @if (f.amount.errors.required) {
              <div>Refund amount is required</div>
            }
            @if (f.amount.errors.min) {
              <div>Refund amount must be greater than 0</div>
            }
            @if (f.amount.errors.max) {
              <div>Refund amount cannot be more than {{maxRefundable | number: '1.2-2'}}</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-md-4 col-form-label">Reason for Refund</label>
      <div class="col-md-8">
        <textarea formControlName="reason" class="form-control" rows="6"
          [ngClass]="{'is-invalid': submitted && f.reason.errors}"></textarea>
        @if (submitted && f.reason.errors) {
          <div class="invalid-feedback">
            @if (f.reason.errors.required) {
              <div>Reason for refund is required</div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Cancel</button>
    <button type="submit" class="btn btn-primary">Submit</button>
  </div>
</form>
